<template>
    <div class="c-input__block">
        <div class="c-input__item">
            <div class="c-input__header is-required">
                メールアドレス
            </div>
            <div class="c-input__area" :class="[{'is-error': validations.email.isValid}, {'is-error':isCheckMail}]">
                <input type="email" name="MAIL" placeholder="入力してください" v-model="user.email" v-on:blur="checkMail">
                <div class="c-input__error u-mb10-pc u-mb10-sp" v-if="validations.email.isValid && isCheckMail == false">
                    <p class="c-input__error-match is-show">
                        正しいメールアドレスを入力してください。
                    </p>
                </div>
                <div class="c-input__error u-mb10-pc u-mb10-sp" v-if="isCheckMail && validations.email.isValid == false">
                    <p class="c-input__error-match is-show" v-for="(mail_msg, key) in errors.MAIL" :key="key">
                        {{ mail_msg }}
                    </p>
                </div>
                <div class="c-input__caution">
                    <p>ドメイン指定受信などの迷惑メール対策を設定されている場合、「grajapa.shueisha.co.jp」から送信されるメールを受信できるようにしてください。</p>
                </div>
            </div>
        </div>
        <div class="c-input__item">
            <div class="c-input__header is-required">
                パスワード
            </div>
            <div class="c-input__area c-input__password c-input__password1"
                :class="{'is-error': validations.password.isValid || isCheckPassword}">
                <input type="password" name="PASSWORD" placeholder="入力してください" v-model="user.password" v-on:blur="checkPass" autocomplete="off">
                <div class="c-input__error" v-if="validations.password.isValid && isCheckPassword == false">
                    <p class="c-input__error-rule is-show">8文字以上の半角英数字で入力してください。</p>
                </div>
                <div class="c-input__error" v-if="isCheckPassword && validations.password.isValid == false">
                    <p class="c-input__error-rule is-show" v-for="(password_msg, key) in errors.PASSWORD" :key="key">
                        {{ password_msg }}
                    </p>
                </div>
		        <div class="c-input__caution"></div>
            </div>
        </div>
        <div class="c-input__item">
            <div class="c-input__header is-required">
                パスワード再確認
            </div>
            <div class="c-input__area c-input__password c-input__password2" :class="{'is-error': isNotMatch || isCheckPasswordConf}">
                <input type="password" name="PASSWORD_CONF" placeholder="入力してください" v-model="passMatch" v-on:blur="checkPassMatch" autocomplete="off">
                <div class="c-input__error" v-if="isNotMatch && isCheckPasswordConf == false">
                    <p class="c-input__error-match is-show" :class="{'is-show': isNotMatch}">パスワードが一致しません。</p>
                </div>
                <div class="c-input__error" v-if="isCheckPasswordConf && isNotMatch == false">
                    <p class="c-input__error-match is-show" v-for="(password_conf_msg, key) in errors.PASSWORD_CONF" :key="key">
                        {{ password_conf_msg }}
                    </p>
                </div>
		        <div class="c-input__caution"></div>
            </div>
        </div>
        <div class="c-input__item">
            <div class="c-input__header">
                ニックネーム
            </div>
            <div class="c-input__area c-input__password" :class="{'is-error': isCheckNickname}">
                <input type="text" name="NICK_NAME" v-model="user.nickname" placeholder="入力してください">
                <div class="c-input__error" v-if="isCheckNickname">
                    <p class="c-input__error-match is-show" v-for="(nickname_msg, key) in errors.NICK_NAME" :key="key">
                        {{ nickname_msg }}
                    </p>
                </div>
                <div class="c-input__caution">
                    <p>登録後に変更可能です。こちらはマイアイテムで使用されます。</p>
                </div>
            </div>
        </div>
        <div class="c-input__item">
            <div class="c-input__header is-required">
                性別
            </div>
            <div class="c-input__area" :class="{'is-error': validations.sex.isValid || isCheckSex}">
                <div class="c-input__radio-wrapper">
                    <input id="radio-1" name="SEX" type="radio" value="M" v-model="user.sex">
                    <label for="radio-1" class="c-radio__label">男性</label>
                </div>
                <div class="c-input__radio-wrapper">
                    <input id="radio-2" name="SEX" type="radio" value="F" v-model="user.sex">
                    <label for="radio-2" class="c-radio__label">女性</label>
                </div>
                <div class="c-input__radio-wrapper">
                    <input id="radio-0" name="SEX" type="radio" value="N" v-model="user.sex">
                    <label for="radio-0" class="c-radio__label">設定しない</label>
                </div>
                <div class="c-input__error u-mt10-sp" v-if="validations.sex.isValid && isCheckSex == false">
                    <p class="c-input__error-match is-show">性別を選択してください。</p>
                </div>
                <div class="c-input__error" v-if="isCheckSex && validations.sex.isValid == false">
                    <p class="c-input__error-match is-show" v-for="(sex_msg, key) in errors.SEX" :key="key">
                        {{ sex_msg }}
                    </p>
                </div>
            </div>
        </div>
        <div class="c-input__item">
            <div class="c-input__header is-required">
                生年月
            </div>
            <div class="c-input__area" :class="{'is-error': validations.birthday.month || isCheckBirthdayYear || isCheckBirthdayMonth || isCheckBirthday }">
                <div class="c-input__birthday">
                    <div class="c-input__selectbox-wrapper c-input__selectbox-year">
                        <select class="browser-default" name="BIRTHDAY_YEAR" tabindex="-1" v-model="user.birthday.year">
                            <option v-for="n in this.years.period+1" :key="n" :value="n + year_min-1">{{ n + year_min-1 }}</option>
                        </select>
                        <label for="">年</label>
                    </div>
                    <div class="c-input__selectbox-wrapper c-input__selectbox-month">
                        <select class="browser-default" name="BIRTHDAY_MONTH" tabindex="-1" v-model="user.birthday.month" @change="checkMonth">
                            <option disabled value="--">--</option>
                            <option v-for="n in 12" :key="n" :value="n">{{ n }}</option>
                        </select>
                        <label for="">月</label>
                    </div>
                </div>
                <div class="c-input__error u-mt10-pc u-mt10-sp" v-if="validations.birthday.month || isCheckBirthday">
                    <p class="c-input__error-match is-show">
                        正しい生年月を入力してください。
                    </p>
                </div>
                <div class="c-input__error u-mt10-pc u-mt10-sp" v-if="isCheckBirthdayYear">
                    <p class="c-input__error-match is-show" v-for="(birthday_year_msg, key) in errors.BIRTHDAY_YEAR" :key="key">
                        {{ birthday_year_msg }}
                    </p>
                </div>
                <div class="c-input__error u-mt10-pc u-mt10-sp" v-if="isCheckBirthdayMonth">
                    <p class="c-input__error-match is-show" v-for="(birthday_month_msg, key) in errors.BIRTHDAY_MONTH" :key="key">
                        {{ birthday_month_msg }}
                    </p>
                </div>
                <div class="c-input__caution u-mt10-pc u-mt10-sp">
                    <p>生年月は変更できません。</p>
                </div>
            </div>
        </div>
        <div class="c-input__confirm">
            <div class="c-input__checkbox-wrapper">
                <input id="box1" type="checkbox" name="ISSEND_SHUPURE_ML" v-model="user.issendml" :value="user.issendml" autocomplete="off">
                <label for="box1">
                    週プレ グラジャパ！からメルマガを受け取る</label>
                <p class="issend_shupure_ml_note">（新着情報やお得なセール情報などのお知らせ）</p>
                <p class="issend_shupure_ml_note2">
                    ※利用規約や料金の変更、登録や決済関連などお客様が受け取らないことにより、お客様に不利益が生じる場合は送信させて頂きます。
                </p>
            </div>
            <div class="c-input__error is-show" v-if="isCheckIssendMl">
                <p class="c-input__error-match" v-for="(isset_mail_msg, key) in errors.ISSEND_SHUPURE_ML" :key="key">
                    {{ isset_mail_msg }}
                </p>
            </div>
            <div class="c-input__checkbox-wrapper" :class="{'is-checked': validations.isCheck2}">
                <input id="box2" type="checkbox" name="AGREE" v-model="isCheck2" :value="isCheck2" autocomplete="off">
                <label for="box2"><a :href="route(route_list, 'site.terms')" target="_blank">利用規約</a>と<a :href="route(route_list, 'site.privacy')" target="_blank">個人情報</a>の取扱に<br class="is-sp">同意します</label>
            </div>
            <div class="c-input__error" :class="{'is-show': validations.isCheck2 && isCheckAgree == false}">
                <p class="c-input__error-match">「利用規約と個人情報の取扱に同意します」にチェックが入っていません。</p>
            </div>
            <div class="c-input__error is-show" v-if="isCheckAgree && validations.isCheck2 == false">
                <p class="c-input__error-match" v-for="(agree_msg, key) in errors.AGREE" :key="key">
                    {{ agree_msg }}
                </p>
            </div>
        </div>
        <div class="c-input__confirm" v-if="isCheckReCaptchaScore">
            <div class="c-input__error is-show">
                <p class="c-input__error-match is-show" v-for="(recaptcha_msg, key) in errors.reCAPTCHA_SCORE" :key="key">
                    {{ recaptcha_msg }}
                </p>
            </div>
        </div>
        <div class="c-btn-important1">
            <button type="button" @click="addNewUser">確認</button>
        </div>
        <input type="hidden" id="g-recaptcha-response" name="g-recaptcha-response">
    </div>
</template>

<script>
import moment from 'moment';
import routeMixin from '../../mixins/route.js';
    export default {
        props: [
            'errors',
            'old',
            'years',
            'input',
            'route_list'
        ],
        mixins: [routeMixin],
        data() {
            return {
                isNotMatch: false,
                passMatch: null,
                isCheck1: false,
                isCheck2: false,
                isCheckMail: false,
                isCheckPassword: false,
                isCheckPasswordConf: false,
                isCheckNickname: false,
                isCheckSex: false,
                isCheckBirthdayYear: false,
                isCheckBirthdayMonth: false,
                isCheckBirthday: false,
                isCheckIssendMl: false,
                isCheckAgree: false,
                isCheckReCaptchaScore: false,
                user: {
                    email: this.old.MAIL == undefined ? this.input.MAIL : this.old.MAIL,
                    password: null,
                    sex: this.old.SEX == undefined ? this.input.SEX : this.old.SEX,
                    nickname: this.old.NICK_NAME == undefined ? this.input.NICK_NAME : this.old.NICK_NAME,
                    issendml: this.old.ISSEND_SHUPURE_ML == undefined ? this.input.ISSEND_SHUPURE_ML : this.old.ISSEND_SHUPURE_ML,
                    birthday: {
                        year: this.old.BIRTHDAY_YEAR == undefined ? this.input.BIRTHDAY_YEAR : this.old.BIRTHDAY_YEAR,
                        month: this.old.BIRTHDAY_MONTH == undefined ? this.input.BIRTHDAY_MONTH : this.old.BIRTHDAY_MONTH,
                    }
                },
                year_min: this.years.min_year,
                validations: {
                    email: {
                        isValid: false,
                        regex: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
                    },
                    password: {
                        isValid: false,
                        regex:/^(?=.*?[a-z])(?=.*?\d)[a-z\d]{8,128}$/i
                    },
                    birthday: {
                        year: false,
                        month: false,
                    },
                    sex: {
                        isValid: false,
                    },
                    isCheck2: false,
                },
            }
        },
        methods: {
            addNewUser: function(e) {
                this.checkMail();
                this.checkPass();
                this.checkPassMatch();
                this.checkMonth();
                this.checkSex();
                if (!this.isCheck2) {
                    this.validations.isCheck2 = true;
                } else {
                    this.validations.isCheck2 = false;
                }
                if (
                    this.validations.email.isValid ||
                    this.validations.password.isValid ||
                    this.isNotMatch ||
                    this.validations.isCheck2 ||
                    this.validations.sex.isValid
                ) {
                    return false;
                }

                // グローバルで読み込まれたreCAPTCHAのメソッドを呼び出す
                try {
                    grecaptcha.enterprise.ready(function () {
                        try {
                            grecaptcha.enterprise.execute(re_captcha_token, {action: 'register'}).then(function (token) {
                                $('#g-recaptcha-response').val(token);
                                // vue側で待てないため、こっちでsubmitする
                                $('#form').submit();
                            }).catch(function () {
                                $('#form').submit();
                            });
                        } catch (e) {
                            $('#form').submit();
                        }
                    });
                } catch (e) {
                    $('#form').submit();
                }
                // e.target.form.submit();
            },
            checkPassMatch: function() {
                if (this.passMatch === "" || this.user.password !== this.passMatch) {
                    this.isNotMatch = true;
                } else {
                    this.isNotMatch = false;
                }
            },
            checkPass: function() {
                if (this.user.password === "" || !this.validations.password.regex.test(this.user.password)) {
                    this.validations.password.isValid = true;
                } else {
                    this.validations.password.isValid = false;
                }
            },
            checkMail: function() {
                // ASCII印字可能文字以外が含まれていないか
                const isSingleByteAscii = /^[\x20-\x7E]+$/.test(this.user.email);

                if (this.user.email === "" || !this.validations.email.regex.test(this.user.email) || !isSingleByteAscii) {
                    this.validations.email.isValid = true;
                } else {
                    this.validations.email.isValid = false;
                }
            },
            checkSex: function() {
                if (this.user.sex == null) {
                    this.validations.sex.isValid = true;
                } else {
                    this.validations.sex.isValid = false;
                }
            },
            checkMonth: function() {
                if (this.user.birthday.month == '--') {
                    this.validations.birthday.month = true;
                } else {
                    this.validations.birthday.month = false;
                }
            }
        },
        mounted() {
            M.AutoInit(); // That way, it is only initialized when the component is mounted
            this.$nextTick(() => {
                if (this.errors.MAIL != undefined) {
                    this.isCheckMail = true;
                }
                if (this.errors.PASSWORD != undefined) {
                    this.isCheckPassword = true;
                }
                if (this.errors.PASSWORD_CONF != undefined) {
                    this.isCheckPasswordConf = true;
                }
                if (this.errors.NICK_NAME != undefined) {
                    this.isCheckNickname = true;
                }
                if (this.errors.SEX != undefined) {
                    this.isCheckSex = true;
                }
                if (this.errors.BIRTHDAY_YEAR != undefined) {
                    this.isCheckBirthdayYear = true;
                }
                if (this.errors.BIRTHDAY_MONTH != undefined) {
                    this.isCheckBirthdayMonth = true;
                }
                if (this.errors.BIRTH != undefined) {
                    this.isCheckBirthday = true;
                }
                if (this.errors.AGREE != undefined) {
                    this.isCheckAgree = true;
                }
                if (this.errors.reCAPTCHA_SCORE != undefined) {
                    this.isCheckReCaptchaScore = true;
                }
            });
        },
    }
</script>

<style lang="scss" scoped>
.c-input__block {
    max-width: 702px;
    margin: 0 auto;
}

.c-input__confirm {
    @media screen and (min-width: 768px) {
        padding-top: 20px;
    }
}

.c-input__checkbox-wrapper {
    width: 340px;
}

.issend_shupure_ml_note {
    margin: 10px 0 5px 30px;
    font-size: 14px;
    color: #85949e;
    @media screen and (max-width: 767px) {
        font-size: 12px;
    }
}
.issend_shupure_ml_note2 {
    font-size: 12px;
    margin: 5px 0 20px 30px;
    color: #85949e;
    line-height: 25px;
}

@media screen and (max-width: 767px) {
    .c-input__birthday {
        display: flex;
        align-items: center;
        justify-content: flex-start;

        .c-input__selectbox-wrapper {
            display: flex;
            align-items: center;
            margin-right: 5px;
            margin-bottom: 0;

            &:last-child {
                margin-right: 0;
            }

            label {
                padding-left: 5px;
                position: relative;
            }
        }
    }
}

.c-input__confirm {
    .c-input__error {
        text-align: left;
        background-color: #ff0060;
        border-radius: 4px;
        color: #fff;
        padding: 5px 10px;
        display: none;
        font-size: 11px;
        line-height: 17px;

        &.is-show {
            display: block;
        }
    }
}
</style>
